module.exports = __webpack_public_path__ + "static/media/player-red.5cd77daf.svg";